export default "__VITE_ASSET__BN3lgih0__"